import React, { useEffect, useState } from "react";
import api from "../api";
import { toast } from "sonner";
import { Plus, Trash, IdentificationCard, X } from "@phosphor-icons/react";

const empty = { email: "", name: "", password: "", phone: "" };

export default function Drivers() {
  const [items, setItems] = useState([]);
  const [show, setShow] = useState(false);
  const [form, setForm] = useState(empty);

  async function load() {
    const r = await api.get("/drivers");
    setItems(r.data);
  }
  useEffect(() => { load(); }, []);

  async function submit(e) {
    e.preventDefault();
    try {
      await api.post("/drivers", form);
      toast.success("Driver added");
      setShow(false); setForm(empty);
      load();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Failed");
    }
  }

  async function del(d) {
    if (!window.confirm(`Remove driver ${d.name}?`)) return;
    await api.delete(`/drivers/${d.id}`);
    toast.success("Driver removed");
    load();
  }

  return (
    <div className="space-y-5" data-testid="drivers-page">
      <div className="flex items-end justify-between gap-3">
        <div>
          <div className="text-xs font-bold uppercase tracking-[0.3em] text-[#5C738A]">Workforce</div>
          <h1 className="font-heading text-3xl font-black tracking-tight text-[#012340] mt-1">Drivers</h1>
        </div>
        <button className="btn-primary" onClick={() => setShow(true)} data-testid="driver-new-btn">
          <Plus size={16} weight="bold" className="mr-1.5" /> New Driver
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {items.map((d) => (
          <div key={d.id} className="bg-white border border-[#012340]/10 rounded-sm p-5" data-testid={`driver-card-${d.id}`}>
            <div className="flex items-start justify-between">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 rounded-sm bg-[#012340] text-[#CFAB7A] grid place-items-center">
                  <IdentificationCard size={22} weight="bold" />
                </div>
                <div>
                  <div className="font-heading font-bold text-lg text-[#012340]">{d.name}</div>
                  <div className="text-xs text-[#5C738A]">{d.email}</div>
                </div>
              </div>
              <button onClick={() => del(d)} className="p-1.5 rounded-sm hover:bg-[#D32F2F]/10 text-[#D32F2F]" data-testid={`driver-del-${d.id}`}>
                <Trash size={16} weight="bold" />
              </button>
            </div>
            <div className="mt-4 text-sm">
              <div className="text-[#5C738A]">Phone</div>
              <div className="font-semibold text-[#012340]">{d.phone || "—"}</div>
            </div>
          </div>
        ))}
        {!items.length && <div className="text-sm text-[#5C738A]">No drivers yet.</div>}
      </div>

      {show && (
        <div className="fixed inset-0 z-40 bg-black/40 grid place-items-center p-4" onClick={() => setShow(false)}>
          <form onClick={(e) => e.stopPropagation()} onSubmit={submit} className="bg-white w-full max-w-md rounded-sm border border-[#012340]/10" data-testid="driver-form">
            <div className="px-5 py-4 border-b border-[#012340]/10 flex items-center justify-between">
              <div className="font-heading text-xl font-bold text-[#012340]">New Driver</div>
              <button type="button" onClick={() => setShow(false)}><X size={18} weight="bold" /></button>
            </div>
            <div className="p-5 space-y-3">
              <Field label="Name" required><input className={inputCls} required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="df-name" /></Field>
              <Field label="Email" required><input type="email" className={inputCls} required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="df-email" /></Field>
              <Field label="Password" required><input type="password" className={inputCls} required value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} data-testid="df-password" /></Field>
              <Field label="Phone"><input className={inputCls} value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} /></Field>
            </div>
            <div className="px-5 py-3 border-t border-[#012340]/10 flex justify-end gap-2">
              <button type="button" className="px-4 py-2 rounded-sm border border-[#012340]/20 text-sm font-bold" onClick={() => setShow(false)}>Cancel</button>
              <button type="submit" className="btn-primary" data-testid="driver-save">Create</button>
            </div>
          </form>
        </div>
      )}
    </div>
  );
}

const inputCls = "w-full rounded-sm bg-white border border-[#012340]/20 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#CFAB7A]";
function Field({ label, children, required }) {
  return (
    <div>
      <label className="text-[11px] font-bold uppercase tracking-[0.2em] text-[#5C738A]">{label}{required && <span className="text-[#D32F2F]">*</span>}</label>
      <div className="mt-1">{children}</div>
    </div>
  );
}
